import * as UI from "@iyk/ui"
import * as React from "react"

import { Data } from "effect"

type ResendOtpState = Data.TaggedEnum<{
  Idle: {}
  Sent: {}
}>

const ResendOtpState = Data.taggedEnum<ResendOtpState>()

export const ResendOtpCodeButton = ({ onOtpSent }: { onOtpSent: () => void }) => {
  const [countdown, setCountdown] = React.useState(0)

  const handleSendOtp = () => {
    setCountdown(4)
    onOtpSent()
  }

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [countdown])

  const state = countdown > 0 ? ResendOtpState.Sent() : ResendOtpState.Idle()

  return ResendOtpState.$match(state, {
    Idle: () => <IdleResendOtpCode handleSendOtp={handleSendOtp} />,
    Sent: () => <SentResendOtpCode />,
  })
}

const IdleResendOtpCode = ({ handleSendOtp }: { handleSendOtp: () => void }) => {
  return (
    <UI.Button size="md" kind="ghost" className="w-full" type="button" onClick={handleSendOtp}>
      <UI.Icon.Rewatch />
      코드 다시 보내기
    </UI.Button>
  )
}

const SentResendOtpCode = () => (
  <UI.Button size="md" kind="ghost" className="w-full" type="button">
    <UI.Icon.Check />
    코드 전송 완료
  </UI.Button>
)
